export const DEPARTURE_CITY = 'departure-city'
export const ARRIVAL_CITY = 'arrival-city'
export const DEPARTURE_DATE = 'departure-date'
export const DURATION = 'duration'
export const ROOM_INFO = 'room-info'
